import { AmbienteRepository } from './ambiente-repository'
import { api } from '../../plugins/api'

export * from './checklist-item'
export * from './data-bloqueada'
export * from './maximo-reservas'
export * from './taxa'
export * from './config'
export * from './ambiente'
export * from './ambiente-repository'

export const ambiente_repository = new AmbienteRepository(api)